import ConditionsOfUse from 'components/ConditionsOfUse/ConditionsOfUsePresentation'

export default ConditionsOfUse
